type TableCellComparator<T> = (cell1: T, cell2: T) => number;

export const stringCellComparator: TableCellComparator<string> = (cell1: string, cell2: string) => {
  if (cell1 && cell2 && typeof cell1 === 'string' && typeof cell2 === 'string') {
    return cell1.localeCompare(cell2);
  }
  return -1;
};